<template>
  <div>
    <vxe-form>
      <vxe-form-item>
        <!-- <template v-slot> -->
        <vxe-input v-model="searchVal" :placeholder="$t('message.placeholder.search')"
          @keyup.enter.native="searchClick"></vxe-input>
        <!-- </template> -->
      </vxe-form-item>
      <vxe-form-item>
        <template v-slot>
          <div>
            <el-button type="primary" icon="el-icon-search" size="small" @click="searchClick">{{
              $t("message.button.search") }}</el-button>
            <!-- <el-button
              type="success"
              icon="el-icon-folder-checked"
              size="small"
              @click="checkClick"
              >{{ $t("message.button.submit") }}</el-button
            > -->
          </div>
        </template>
      </vxe-form-item>
      <!-- <vxe-form-item>
        <slot></slot>
      </vxe-form-item> -->
    </vxe-form>
    <vxe-grid v-if="!listUsed" ref="xGrid" v-bind="addTableList" @cell-dblclick="dbClick">
      <template v-slot:toolbar>
        <vxe-toolbar>
          <template v-slot:buttons> </template>
        </vxe-toolbar>
      </template>
    </vxe-grid>
    <simple-table v-else ref="searchTable" @rowClick='dbClick' @listAdd="listGetChange" :editCheck="editCheck" />
    <!-- <el-pagination
      small
      v-if="paginationShow"
      class="pagination"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="pageSizes"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalRecords"
    >
    </el-pagination> -->
  </div>
</template>
<script>
import axios from 'axios';
import SimpleTable from '@/views/systerm/dataConfig/list/components/ListType/simple.vue'

export default {
  // name: "searchAdd", //模板名称
  data() {
    return {
      allListValues: [],
      searchVal: "",
      get_change_info: "",
      rols_text: [],
      tableShow: false,
      oldTableValue: [],
      rols_text: [],
      cols: [],
      pageSizes: [100, 200, 500, 1000],
      pageSize: 100,
      currentPage: 1,
      totalRecords: '',
      paginationShow: false,

      listUsed: 0,
      hasAdd: false,
      editCheck: true,

      addTableList: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "530",
        size: "small",
        columns: [],
        data: [],
        // treeConfig: {
        //   lazy: true,
        //   children: "children",
        //   hasChild: "hasChildren",
        //   loadMethod: this.loadChildrenMethod,
        // },
        editConfig: {
          trigger: "dblclick",
          mode: "row",
          showIcon: false,
          // activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: "cell",
        },
        // checkboxConfig:{
        //   labelField: 'name',
        //   checkMethod: this.checkboxMethod}
      },
    };
  },
  mounted() { },
  props: ["listInfo"],
  components: { SimpleTable },
  methods: {
    // handleSizeChange(val) {
    //   console.log(`每页 ${val} 条`);
    //   this.pageSize = val;
    //   this.searchClick()
    // },
    // handleCurrentChange(val) {
    //   console.log(`当前页: ${val}`);
    //   this.currentPage = val;
    //   this.searchClick()
    //   // const { data: res } = await this.$http.get(loadTableUrl);
    // },
    // add() {
    //   this.$emit("addNew");
    // },
    // save(){
    //   this.$emit('saveaa','111')
    // },
    listGetChange(e) {
      this.hasAdd = e;
    },
    dbClick(item) {
      // console.log(row);
      const row = !this.listUsed ? item.row : item;
      if (!row.entryId) {
        // this.$message.warning('请先保存新添加的列表值');
        return
      }
      if (this.hasAdd) {
        this.$message.warning('请先保存新添加的列表值');
        return
      }
      let listInfo = {
        listId: row.listId + "_" + row.entryId,
        listValue: row.entryValue,
        listIndex: this.listInfo.index,
      };
      console.log(listInfo);
      this.$emit("listDbClick", listInfo);
    },
    checkClick() {
      let removeRow = this.$refs.xGrid.getCheckboxRecords();
      console.log(removeRow);
      if (removeRow.length == 0) return false;
      this.$emit("listDbClick", removeRow);
    },
    async searchClick() {
      console.log("clickSearch");

      console.log(this.listUsed);

      if (this.listUsed) {
        this.$refs.searchTable.filterData(this.searchVal);
      } else {

        this.addTableList.data = this.allListValues.filter(i =>
          (i.entryValue += '').toLowerCase().indexOf((this.searchVal += '').toLowerCase()) !== -1
          || (i.entryCode += '').toLowerCase().indexOf((this.searchVal += '').toLowerCase()) !== -1
        );
      }

      // if (this.searchVal == "") {
      //     this.addTableList.data = this.allListValues;
      // }else{
      //   if (this.listUsed) {

      //   } else{

      //   }

      // }
    },
    checkboxMethod({ row }) {
      console.log(row.itemRev);
      // return row.itemRev  != null;
    },
    getxx() {
      console.log(this.listInfo.listId);
      if (this.listInfo.listId == "") {
        return true;
      }
      axios.get('/pmdm/admin/list/getEnabledListEntryByListId?listId=' + this.listInfo.listId)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.$emit('listUpdate', res.data.object.listEntries)
            this.addTableList.data = res.data.object.listEntries;
            this.allListValues = res.data.object.listEntries;
            // console.log(this.allListValues);
            // console.log(this.Constants.changeBaseClassId);
            if (res.data.object.listType == this.Constants.listTypeSimple) {
              this.addTableList.columns.push(
                {
                  sortable: true,
                  field: 'entryValue',
                  title: this.$t('message.table.name')
                }
              );
            } else if (res.data.object.listType == this.Constants.listTypeCode || res.data.object.listType == this.Constants.listTypeSerialNumber
              || res.data.object.listType == this.Constants.listTypeVersionNumber) {
              this.addTableList.columns.push(
                {
                  sortable: true,
                  field: "entryOrder",
                  title: this.$t("message.table.SN"),
                }
              );
              this.addTableList.columns.push(
                {
                  sortable: true,
                  field: "entryCode",
                  title: this.$t("message.table.code"),
                  editRender: {
                    name: "$input",
                  },
                }
              );
              this.addTableList.columns.push(
                {
                  sortable: true,
                  field: 'entryValue',
                  title: this.$t('message.table.name')
                }
              );
            } else if (res.data.object.listType == this.Constants.listTypeReference) {
              this.addTableList.columns.push(
                {
                  sortable: true,
                  field: "entryCode",
                  title: this.$t("message.table.number_"),
                }
              );
              this.addTableList.columns.push(
                {
                  sortable: true,
                  field: "entryValue",
                  title: this.$t("message.table.name"),
                }
              );
              this.addTableList.columns.push(
                {
                  sortable: true,
                  field: "description",
                  title: this.$t("message.table.address"),
                }
              );
            } else if (res.data.object.listType == this.Constants.listTypeDynamic) {

              this.addTableList.columns.push(
                {
                  sortable: true,
                  field: "entryValue",
                  title: this.$t("message.table.name"),
                }
              );

              this.addTableList.columns.push(
                {
                  sortable: true,
                  field: "description",
                  title: this.$t("message.table.des"),
                }
              );
              this.addTableList.columns.push(
                {
                  sortable: true,
                  field: "entryCode",
                  title: this.$t("message.title.createTime"),
                }
              );
            }
          }
        })
    },

    getListInfo() {
      axios.get('/pmdm/admin/list/getListEntriesSimple?listId=' + this.listInfo.listId)
        .then(res => {
          console.log(res);
          this.listUsed = res.data.object.isSimpleList;
          if (!this.listUsed) {
            this.getxx()
          }
        })

    }
  },

  created() {
    console.log(this.listInfo);
    this.$store.commit("setListId", this.listInfo.listId);
    // this.addTableList.data = this.listInfo.listEntrie;
    this.getListInfo();
  },
};
</script>
<style scoped>
.pagination {
  margin-top: 15px;
  text-align: left;
}
</style>